import { Link } from "react-router-dom";
import "./styles/PaymentSuccess.css";

function PaymentSuccess() {
  return (
    <div className="ps-page">
      <div className="ps-card">
        <div className="ps-icon">✅</div>
        <h2 className="ps-title">Ödəniş uğurla tamamlandı</h2>
        <p className="ps-description">Profiliniz yayımlandı!</p>
        <Link to="/kabinetim" className="ps-button">
          Kabinetə keç
        </Link>
      </div>
    </div>
  );
}

export default PaymentSuccess;